import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import * as React from 'react';
export default {
  faFileAlt,
  React
};